import {
	type Recipe,
	type Ingredient,
	type RecipeIngredient,
} from '@prisma/client'
import { formatQuantity } from 'format-quantity'

export function getSlug(name: string) {
	return name.split(/\s/g).join('_').toLowerCase()
}

export function getIngredientString(
	ingredient: Pick<RecipeIngredient, 'amount' | 'unit'> & {
		ingredient: { name: Ingredient['name'] }
	},
) {
	let str = ''
	if (ingredient.amount) {
		str += formatQuantity(ingredient.amount) + ' '
	}
	if (ingredient.unit) {
		str += ingredient.unit + ' '
	}
	str += ingredient.ingredient.name
	return str.trim()
}

const ingredientPlaceholders = [
	'e.g. 1 1/2 tbsp olive oil',
	'e.g. 1 onion, chopped',
	'e.g. 2/3 cup cheddar cheese',
]
export function getIngredientPlaceholder(i: number) {
	return i < ingredientPlaceholders.length
		? ingredientPlaceholders[i]
		: 'Add another ingredient'
}

const instructionPlaceholders = [
	'e.g. Preheat oven to 400 degrees F...',
	'e.g. In a bowl, combine all ingredients...',
	'e.g. Bake for 20 minutes...',
]
export function getInstructionPlaceholder(i: number) {
	return i < instructionPlaceholders.length
		? instructionPlaceholders[i]
		: 'Add another step'
}

export function filterRecipes<T extends Pick<Recipe, 'name'>>(
	filterValue: string,
	recipes: T[],
) {
	if (!filterValue.trim()) {
		return recipes
	}

	const filter = filterValue.trim().toLowerCase()
	return recipes.filter((recipe) => recipe.name.toLowerCase().includes(filter))
}
